import { environment } from "../environments/environment";

// src/app/auth-config.ts
export const msalConfig = {
  auth: {
    clientId: 'a0868be6-e6c1-487b-aab5-0ea3d414dc7e',
    authority: 'https://login.microsoftonline.com/68b865d5-cf18-4b2b-82a4-a4eddb9c5237',
    redirectUri: environment.appUrl /*Angular UI endpoint URL*/

    /*Enable for the localhost debug environment*/
    //redirectUri: 'http://localhost:4200/' 
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const protectedResources = {
  functionApi: {
    endpoint: environment.apiUrl, /*Function app endpoint URL*/

    /*Enable for the localhost environment*/
    //endpoint: 'http://localhost:7109/api/suppliers',

    scopes: [
      'api://e4d87765-4baf-4107-8b08-de4714204d63/access_as_user',
      'openid',
      'profile',
      'offline_access'
    ]
  },
};
